import { render, staticRenderFns } from "./cambioDireccionEntrega.vue?vue&type=template&id=9213d310&"
import script from "./cambioDireccionEntrega.vue?vue&type=script&lang=js&"
export * from "./cambioDireccionEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports